/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
import {IconEntryDevice, IconEntryExitDevice, IconExitDevice} from "../../../../components/buttons/IconButtons";

export const DEVICE_MODEL_NAME = {
    MANTRA_MFSTAB_II: 1,
    PDA_CARIBE_PL50L: 2,
    TELPO_F6: 3,
    TELPO_TPS_980: 4,
    TELPO_TPS_450: 5,
    TELPO_K5: 6,
    TELPO_F10: 7,
    TELPO_F6_T: 8,
    TELPO_K10: 9,
    VERIDAS_1FA: 10,
    VERIDAS_2FA: 11,
    CAMERA_LPR: 12,
    ANTENNA_RFID: 13,
    ARATEK_BM7550: 14,
    ARATEK_BA8300: 15,
    ARATEK_BM5510: 16,
};

export const ANTIPASSBACKTYPE_MODEL = {
    NONE : 1,
    SOFT : 2,
    HARD : 3,
}

export const MODE_MODEL = {
    ACCESS : 1,
    ATTENDANCE : 2,
    ACCESS_AND_ATTENDANCE : 3,
    FOODIE_ACCESS : 4,
    FOODIE_KIOSK : 5,
    FOODIE_CHECK_IN : 6,
    GUARD : 7,
    VISITORS_MANAGEMENT_KIOSK : 8,
    CAMERA_LPR : 9,
    ANTENNA : 10,
    FOODIE_CHECK_OUT: 11,
    RESERVATIONS: 12
}

export const requiredFor = [
    DEVICE_MODEL_NAME.MANTRA_MFSTAB_II, // 1
    DEVICE_MODEL_NAME.PDA_CARIBE_PL50L, // 2
    DEVICE_MODEL_NAME.TELPO_F6,         // 3
    DEVICE_MODEL_NAME.TELPO_TPS_980,    // 4
    DEVICE_MODEL_NAME.TELPO_TPS_450,    // 5
    DEVICE_MODEL_NAME.TELPO_K5,         // 6
    DEVICE_MODEL_NAME.TELPO_F10,        // 7
    DEVICE_MODEL_NAME.TELPO_F6_T,       // 8
    DEVICE_MODEL_NAME.TELPO_K10,        // 9
    DEVICE_MODEL_NAME.ARATEK_BM7550,    // 14
    DEVICE_MODEL_NAME.ARATEK_BA8300,    // 15
    DEVICE_MODEL_NAME.ARATEK_BM5510,    // 16
];

export const DEVICE_ACCESS_TYPE_MODEL = {
    ENTRY: { id: 1, trans: "entry", name: "ENTRY", transWithDevice: "entry_device", Icon: IconEntryDevice ,color : 'icon-color-success-600'},
    EXIT: { id: 2, trans: "exit", name: "EXIT", transWithDevice: "exit_device",Icon: IconExitDevice,color : 'icon-color-error-code-600'},
    ENTRY_EXIT: { id: 3, trans: "entry_exit",name: "ENTRY_EXIT", transWithDevice: "entry_exit_device", Icon: IconEntryExitDevice}
}

export const getDeviceAccessTypeById = (id) => {
    const key = Object.entries(DEVICE_ACCESS_TYPE_MODEL).find(key => key[1]?.id === id);
    return key[1] || null;
}

export const getIconClassesContainer = (list) => {
    if(list.map(e => e.deviceAccessTypeId || e.deviceAccessType?.id).includes(DEVICE_ACCESS_TYPE_MODEL.ENTRY_EXIT.id)) return 'w-46px text-right';
    return '';
}

export const DeviceDetails = {
    deviceId: '',
    deviceName: '',
    idDevice: '',
    zoneName: '',
    zone: '',
    deviceType: '',
    statusValue: '',
    ip: '',
    description: null,
    password: null,
    accessType: '',
    timeZoneValue: '',
    cameraTypeId: 0,
    antiPassBackType: 1,
    antiPassBackTime: '',
    antiPassBackAlert: 1,
    escortMode: 1,
    authentication: 1,
    readAfter: '',
    sn: '',
    mac: '',
    firebaseId: '',
    syncTime: 0,
    validationNumber: 0,
    smartCard: false,
    facialRecognition: false,
    liveness: false,
    qr: false,
    pin: false,
    fingerprint: false,
    bluetooth: false,
    showLogo: false,
    showUserList: false,
    synchorizeSelfies: false,
    playSounds: false,
    requestSignature: 0,
    requestSignatureAlways: false,
    enableTTLock: false,
    enableAirbnk: false,
    enableRelay: '',
    enableRelay0: false,
    enableRelay1: false,
    enableRelaySR3: false,
    enableRelaySR34ch: false,
    deviceRestriction: '',
    delayToOpen: 0,
    timeForRelay0: 0,
    consecutiveOpeningsAllowed: 0,
    timeForRelay1: 0,
    showWeapon: false,
    showVehicle: false,
    showLed: false,
    showAccessDialog: false,
    showLastAccess: false,
    printer: false,
    modeId  : '',
    enableDistance:false,
    distance:null,


    isValid: function (section) {
        const validations = {
            1: () => this.ip && this.mac && this.deviceName && this.statusValue &&
                this.accessType && this.sn && this.deviceType && this.readAfter && this.modeId,
            2: () => {
                if (this.antiPassBackType === ANTIPASSBACKTYPE_MODEL.SOFT || this.antiPassBackType === ANTIPASSBACKTYPE_MODEL.HARD) {
                    return this.antiPassBackTime != 0 && this.antiPassBackTime !== '' && this.antiPassBackAlert;
                }
                return true;
            },
            3: () => this.timeZoneValue,
            4: () => {
                const isRequired = requiredFor.includes(this.deviceType);
                const hasPassword = !!this.password && this.password.trim().length > 0;

                // If there is no password, it always fails
                if (!hasPassword) return false;

                // If required for deviceType, validate minimum length
                if (isRequired && this.password.length < 8) return false;

                return true;
            },
            5: () => {
            if (this.enableDistance) {
                return this.distance !== null && this.distance !== '';
            }
            return true;
            },
            6: () =>
                this.consecutiveOpeningsAllowed !== null &&
                this.consecutiveOpeningsAllowed !== undefined &&
                this.consecutiveOpeningsAllowed !== "",
        };
        return validations[section] ? validations[section]() : false;
    },

    toRegister: function () {
        return {
            deviceName:this.deviceName,
            idDevice:this.idDevice,
            deviceId:this.deviceId,
            zoneName:this.zoneName,
            zone:this.zone,
            deviceType:this.deviceType,
            statusValue:this.statusValue,
            ip:this.ip,
            description:this.description,
            password:this.password,
            accessType:this.accessType,
            antiPassBackType:this.antiPassBackType,
            timeZoneValue:this.timeZoneValue,
            cameraTypeId:this.cameraTypeId,
            antiPassBackTime:this.antiPassBackTime,
            antiPassBackAlert:this.antiPassBackAlert,
            escortMode:this.escortMode,
            authentication:this.authentication,
            readAfter:this.readAfter,
            sn:this.sn,
            mac:this.mac,
            firebaseId:this.firebaseId,
            syncTime:this.syncTime,
            validationNumber:this.validationNumber,
            smartCard:this.smartCard,
            facialRecognition:this.facialRecognition,
            liveness:this.liveness,
            qr:this.qr,
            pin:this.pin,
            fingerprint:this.fingerprint,
            bluetooth:this.bluetooth,
            showLogo:this.showLogo,
            showUserList:this.showUserList,
            synchorizeSelfies:this.synchorizeSelfies,
            playSounds:this.playSounds,
            requestSignature:this.requestSignature,
            requestSignatureAlways:this.requestSignatureAlways,
            enableTTLock:this.enableTTLock,
            enableAirbnk:this.enableAirbnk,
            enableRelay:this.enableRelay,
            enableRelay0:this.enableRelay0,
            enableRelay1:this.enableRelay1,
            enableRelaySR3:this.enableRelaySR3,
            enableRelaySR34ch:this.enableRelaySR34ch,
            deviceRestriction:this.deviceRestriction,
            delayToOpen:this.delayToOpen,
            timeForRelay0:this.timeForRelay0,
            consecutiveOpeningsAllowed:this.consecutiveOpeningsAllowed,
            timeForRelay1:this.timeForRelay1,
            showWeapon:this.showWeapon,
            showVehicle:this.showVehicle,
            showLed:this.showLed,
            showAccessDialog:this.showAccessDialog,
            showLastAccess:this.showLastAccess,
            printer:this.printer,
            modeId : this.modeId,
            enableDistance:this.enableDistance,
            distance:this.distance,
        };
    }
};

